import { Component, OnInit } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  public selectedIndex = 0;
  public appPages = [
    {
      title: 'หน้าหลัก',
      url: '/home',
      icon: 'home'
    },
    {
      title: 'Profile',
      url: '/profile',
      icon: 'person'
    },
    {
      title: 'ข้อมูลรถ',
      url: '/car-dashboard',
      icon: 'car'
    },
    {
      title: 'Order',
      url: '/order',
      icon: 'document'
    },
    {
      title: 'ติดตามงาน (หัวหน้า)',
      url: '/map',
      icon: 'location'
    },
    {
      title: 'ติดตามงาน (ลูกค้า)',
      url: '/track',
      icon: 'notifications'
    },
    {
      title: 'ใบรับงานสินค้า',
      url: '/recieve',
      icon: 'receipt'
    },
    {
      title: 'สรุปค่าใช้จ่าย',
      url: '/summary',
      icon: 'cash'
    },
    {
      title: 'แบบฟอร์มคุมเฝ้า (Fo export)',
      url: '/report-list',
      icon: 'documents'
    }
  ];

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  ngOnInit() {
    const path = window.location.pathname.split('folder/')[1];
    if (path !== undefined) {
      this.selectedIndex = this.appPages.findIndex(page => page.title.toLowerCase() === path.toLowerCase());
    }
  }
}
